module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrapper"
    }
  }, [_c('app-sidebar'), _vm._v(" "), (_vm.hasPermission && _vm.levv != '') ? _c('app-content', {
    on: {
      "opentip": _vm.opentip
    }
  }) : _vm._e(), _vm._v(" "), _c('AppRightSidebar'), _vm._v(" "), _c('AppAlarmRightSidebar', {
    on: {
      "openAlarm": _vm.openAlarm,
      "opentip": _vm.opentip
    }
  }), _vm._v(" "), (_vm.showBackMission) ? _c('AppBackMission', {
    attrs: {
      "stopped": _vm.stopped
    },
    on: {
      "stopTask": _vm.stopTask,
      "openTip": _vm.opentip
    }
  }) : _vm._e(), _vm._v(" "), _c('main-modal', {
    ref: "mModal",
    attrs: {
      "size": "large",
      "title": "报警处理"
    },
    on: {
      "cancel": _vm.closeModal
    }
  }, [_c('div', [_c('page-alarm-handle-edit', {
    attrs: {
      "data": _vm.alarmDetail
    },
    on: {
      "handleSave": _vm.closeAlarm
    }
  })], 1)]), _vm._v(" "), _c('main-modal', {
    ref: "bModal",
    attrs: {
      "size": "large",
      "title": "警告"
    },
    on: {
      "cancel": _vm.closeWarning
    }
  }, [_c('div', [_c('p', [_vm._v("该任务尚未完成，中断后此任务将被取消，您确定要继续吗？")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closeWarning
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.confirmToStop
    }
  }, [_vm._v("确定")])])]), _vm._v(" "), _c('main-modal', {
    ref: "tModal",
    attrs: {
      "size": "small",
      "title": "温馨提示"
    },
    on: {
      "cancel": _vm.closetip
    }
  }, [_c('div', [_c('p', [_vm._v(_vm._s(_vm.tipContent))])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.closetip
    }
  }, [_vm._v("关闭")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-437379f0","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Home.vue
// module id = 1494
// module chunks = 0